import { connect } from "react-redux";
import { guiEmail, showModalGuiEmail } from "actions/GuiEmail";
import GuiEmail from "components/CommonComponent/GuiEmail";

const mapStateToProps = (state) => ({
  guiemail: state.guiemail,
  camdo: state.camdo,
});

const mapDispatchToProps = (dispatch) => ({
  guiEmail: (dataPost) => dispatch(guiEmail(dataPost)),
  showModalGuiEmail: () => dispatch(showModalGuiEmail()),
});

export default connect(mapStateToProps, mapDispatchToProps)(GuiEmail);
